import {
  Grid, Button, Stack,
  Paper, Typography,Alert,AlertTitle, IconButton
} from '@mui/material';

const ErrorPrompt = ({message, title, ...ppp})=>{

  let t= Boolean(title) ? title:'Error occured';

  let content = null

  if (Boolean(message))
  {
      content = 
      <Alert severity={'error'} {...ppp}> 
            <AlertTitle>{t}</AlertTitle>
              <h3>{message}</h3>
      </Alert> 
  }
  return      content
        
}

export default ErrorPrompt;